module.exports = __webpack_public_path__ + "img/cj-right.573a7e99.jpg";